import { render } from "./Tiptap.vue?vue&type=template&id=05618f0c&scoped=true"
import script from "./Tiptap.vue?vue&type=script&lang=js"
export * from "./Tiptap.vue?vue&type=script&lang=js"

import "./Tiptap.vue?vue&type=style&index=0&id=05618f0c&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-05618f0c"

export default script